import { FunctionComponent, ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { format } from "date-fns/format";
import { differenceInDays } from "date-fns/differenceInDays";
import { Course } from "../courses/courses.types";
import { WarningBannerSuperscript } from "../components/banners/WarningBannerSuperscript";
import { COURSE_ARCHIVE_OVERLAP_PERIOD } from "../common/constants";

export type CourseLabelProps = {
  course:Course
  selectionSet:Set<number>;
  select :(id: number, name: string) => void;
  deselect: (id: number) => void;
};



export const CourseLabel:FunctionComponent<CourseLabelProps>  = ({ course, selectionSet, select, deselect }) => {
    const { t } = useTranslation();

    const showWarningBanner =
        !!course.toBeArchivedOn &&
        differenceInDays(course.toBeArchivedOn, new Date()) <= COURSE_ARCHIVE_OVERLAP_PERIOD;

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked) select(course.id, course.title);
        else deselect(course.id);
    };

    return (
        <>
            <input
                type="checkbox"
                id={`${course.id}`}
                disabled={showWarningBanner}
                checked={selectionSet.has(course.id)}
                onChange={handleChange}
            />
            <label htmlFor={`${course.id}`}>
                {showWarningBanner ? (
                    <WarningBannerSuperscript
                        title={course.title}
                        message={t("deepLinking.courseWillBeArchivedSoonDeeplinkingMessage", {
                            toBeArchivedOn: format(course.toBeArchivedOn!, "dd.MM.yyyy"),
                        })}
                    />
                ) : (
                    <div>{course.title}</div>
                )}
            </label>
        </>
    );
}
